export default __webpack_public_path__ + "static/media/30.7de26c0f.png";